module.exports = __webpack_public_path__ + "static/media/avatar.be3436fa.svg";